import React, { useEffect, useState } from 'react';

import gox from '../../assets/gox.png';
import DateInput from '../../components/Date/Date';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { createaccounts } from '../../action/createaccount';
import { useDispatch, useSelector } from 'react-redux';
import RoundProgressButton from '../Home/progress1'
import { signin } from '../../action/user';


function Home2({ data, setCurrentTab}) {
  const navigate = useNavigate()


  const [progress, setProgress] = useState(0);

  const handleProgressClick = () => {
    setProgress(2);
  }
  // const location = useLocation();
  // const {
  //   firstName,
  //   lastName,
  //   email,
  //   phoneNumber,
  //   password,
    
  // } = location.state;
  
    // const { firstName, lastName, email, phoneNumber, password } = useParams();
  
    // Now, you can use these values in your Home2 component.
  


  const dispatch = useDispatch()

  function handleSubmit(e){
    e.preventDefault()//this will prevent action without refreshing your page

    const form = new FormData(e.currentTarget) //this stores all the information on the input
  }

  const state = useSelector((state) => state?.create)
  console.log(state)
const test = useSelector((state) => state?.signin)
  useEffect(() => {
    if(state?.create?.user) {
      dispatch(signin(data?.email, data?.password))
      console.log('dispatched')
    }
  }, [state])

  console.log(test)


  useEffect(() => {
    if(test?.signin?.access) {
      navigate('/OTP')
    }
  }, [test])

  const [companyName, setCompanyName] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [industry, setIndustry] = useState('');
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [termsIsAccepted, setTermsIsAccepted] = useState(false);
  const [selectedDate, setSelectedDate] = useState('')
  // const isPage2Valid = companyName && companySize && industry && registrationNumber && termsIsAccepted;
  const handleCreateAccount = () => {

    if ( companyName && companySize && industry && registrationNumber && termsIsAccepted && selectedDate) {
      // console.log (s, companySize, industry, registrationNumber, termsIsAccepted, selectedDate)
      const newCompany = {
        "name": companyName,
        // "company_email": "idowuoluwodfdreubrieubdfle18@gmail.com",
        "company_size": companySize,
        "industry": industry,
        "rc_number": registrationNumber,
        "incorporation_date": selectedDate
      }
      console.log(data, newCompany)
      // setData({
      //   ...data,
      //   company: [...data.company, newCompany],
      // });
      // console.log(data)

      // console.log(newCompany)

      // setData({
      //   ...data,
      //   company: data.company.concat(newCompany),
      // });

      dispatch(createaccounts(
    data,
      newCompany
      ))
    } else {
      console.log('fill in all forms')
    }
   }



  return (
    <>
      <div className=' banner d-flex'>

        <div className="left px-5 py-5">
          <div className='pb-5'> <h6>GOX Register</h6></div>
          <div>

            <div className='pt-5 pb-5'>
              <h1> Management-Focused Financial Solution</h1>
              <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum 
                et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit 
                interdum et feugiat odio.
              </p>
            </div>

            <div className='dynamic p-3'>
              <p>
                In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of
                employee well-being. We see our mission as not just managing resources, but as stewards of an environment
                where each person's unique skills and perspectives are valued.
              </p>
              <div className='d-flex mt-5 '>
                <div className='mx-2'><img src={gox} alt="logo" /></div>
                <div>
                  <h6>Gox register</h6>
                  <p>Our mission</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div>
          {/* <Link to='/'> */}
            <button type="submit" className="btn btn1 m-5 back w-50 text-white" onClick={() => setCurrentTab('page1')}>Back</button>
          {/* </Link> */}
        </div>

        <div className="container forms mt-5 ">
          <div className="">
            <div className=" welcome col-md-6">
              <h1>Create your account</h1>
              <p>Enter details below to create account.</p>
            </div>
            <div className="col-md-6">
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="mb-3">
                  <div className="row">
                    <div className="">
                      <label htmlFor="companyName" className="form-label">Company name</label>
                      <input
                        type="text"
                        className="form-control w-100"
                        id="companyName"
                        placeholder="Company Name"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </div>
                    <div className="">
                      <label htmlFor="companySize" className="form-label">Company Registration number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="companySize"
                        placeholder="Enter RC number"
                        value={registrationNumber}
                        onChange={(e) => setRegistrationNumber(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="industry" className="form-label">Industry</label>
                  <select
                    className="form-select"
                    id="industry"
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                  >
                    <option value="">Select industry</option>
                    <option value="IT">Information Technology</option>
                    <option value="Finance">Finance</option>
                    <option value="Healthcare">Healthcare</option>
                    {/* Add more options as needed */}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="registrationNumber" className="form-label">Company size</label>
                  <input
                    type="number"
                    className="form-control"
                    id="registrationNumber"
                    placeholder="Number of employee"

                    value={companySize}
                        onChange={(e) => setCompanySize(e.target.value)}
                   
                  />
                </div>

                <div>
                  <DateInput selectedDate={selectedDate} setSelectedDate={setSelectedDate}/>
                </div>

                <div className="mb-3 form-check">
                  <input type="checkbox" className="form-check-input" id="acceptTerms"onChange={() => setTermsIsAccepted(!termsIsAccepted)} />
                  <label className="form-check-label" htmlFor="acceptTerms">I accept the terms and conditions</label>
                </div>

                <div className='d-flex justify-content-between my-5' onClick={handleProgressClick}>
                <button onClick={handleCreateAccount} className="btn btn1 w-100">Create account</button>


                </div>
              </form>
              <div className="mt-3">
                <p>Already have an account? <a href="#">Sign in</a></p>
              </div>
            </div>
          </div>
        </div>

     <div className="progress-container">
     <RoundProgressButton progress={`${progress}/2`} />
    </div>

      </div>
    </>
  )
}

export default Home2;
